import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
} from "@store/slices/authSlice";
import { BASE_URL } from "@utils/constants";
import { jwtDecode } from "jwt-decode";
import apiClient from "@/services/api/apiClient";

export const loginUser = createAsyncThunk(
  "auth/login",
  async (credentials, { dispatch }) => {
    try {
      console.log("BASE_URL:", BASE_URL);
      console.log("Login request to:", BASE_URL + "api/user/login");
      console.log("Credentials:",  credentials);
      dispatch(loginStart());
      const response = await fetch(BASE_URL + "api/user/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: credentials.username,
          password: credentials.password,
          captchaToken: credentials.captchaToken,
          captchaInput: credentials.captchaInput,
        }),
      }).catch((error) => {
        console.error("Fetch error:", error.message, error);
        throw error;
      });

      console.log("Response status:", response.status);
      console.log("Response headers:", [...response.headers.entries()]);

      const data = await response.json();
      console.log("Response data:", data);

      if (data.status!=='success') {
        throw new Error(data.message || "Login failed");
      }

      const authToken = data.data;
      if (authToken) {
        const decoded = jwtDecode(authToken);
        console.log("Decoded JWT:", decoded);
        dispatch(
          loginSuccess({
            user: decoded.sub,
            role: decoded.role,
            token: authToken,
            organizationId: decoded.organizationId,
            ministryId: decoded.ministryId,
            userId: decoded.userId,
          })
        );
      } else {
        throw new Error("Authentication token not found in response");
      }
      return data.data;
    } catch (error) {
      console.error("Login error:", error.message, error.stack);
      dispatch(loginFailure(error.message));
      throw error;
    }
  }
);

export const logoutUser = () => async (dispatch, getState) => {
  dispatch(logout());
  {console.log(getState().auth.token)}

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getState().auth.token}`,
    },
    credentials: "include",
  };

  try {
    const response = await fetch(
      BASE_URL + "api/user/logout",
      requestOptions
    );
  } catch (error) {
    console.log(error);
    return error
  }
};

export const refreshToken = createAsyncThunk(
  "auth/refreshToken",
  async (_, { dispatch, getState }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      console.log("Refresh token request to:", BASE_URL + "api/user/refresh-token");

      const response = await fetch(BASE_URL + "api/user/refresh-token", {
        method: "get",
        credentials: "include",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }).catch((error) => {
        console.error("Fetch error:", error.message, error);
        throw error;
      });

      console.log("Refresh response status:", response.status);
      console.log("Refresh response headers:", [...response.headers.entries()]);

      const data = await response.json();
      console.log("Refresh response data:", data);

      if (response.status !== 200 || data.status !== "success") {
        throw new Error(data.message || "Token refresh failed");
      }

      const authToken = data.data;
      if (!authToken) {
        throw new Error("Authentication token not found in response");
      }

      const decoded = jwtDecode(authToken);
      console.log("Decoded refresh JWT:", decoded);
      dispatch(
        loginSuccess({
          user: decoded.sub,
          role: decoded.role,
          token: authToken,
          organizationId: decoded.organizationId,
          ministryId: decoded.ministryId,
          userId: decoded.userId,
        })
      );

      return authToken;
    } catch (error) {
      console.error("Refresh token error:", error.message, error.stack);
      throw error;
    }
  }
);

export const getAllSalutations = (navigate) => async (dispatch, getState) => {
  const state = getState();
  const token = state.auth.token;
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    credentials: "include",
  };

  try {
    const response = await apiClient(
      BASE_URL + "api/user/salutations",
      requestOptions,
      navigate
    );
    if (response.success) {
      return response;
    }
  } catch (error) {
    console.log(error);
  }
}

export const getAllRoles = (navigate) => async (dispatch, getState) => {
  const state = getState();
  const token = state.auth.token;
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    credentials: "include",
  };

  try {
    const response = await apiClient(
      BASE_URL + "api/user/roles",
      requestOptions,
      navigate
    );
    if (response.success) {
      return response;
    }
  } catch (error) {
    console.log(error);
  }
}


export const getAllQuestions = (navigate) => async (dispatch, getState) => {
  const state = getState();
  const token = state.auth.token;
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
    credentials: "include",
  };

  try {
    const response = await apiClient(
      BASE_URL + "api/user/questions",
      requestOptions,
      navigate
    );
    if (response.success) {
      return response;
    }
  } catch (error) {
    console.log(error);
  }
}